import React from "react";
import Wrapper from "../../Components/Wrapper/wrapper";
import { Pageheader } from "../../Constants/pageheader";
import { StudentList } from "../../Components/student/StudentsList";

export const StudentListPage = () => {
  return (
    <Wrapper header={Pageheader.Students}>
      <StudentList />
    </Wrapper>
  );
};
